module.exports = __webpack_public_path__ + "static/media/img16.dda5ab08.jpg";